import { useEffect, useState } from 'react';
import { LANDSCAPE_MOBILE_BREAKPOINT, LARGE_MOBILE_BREAKPOINT } from '@constants';

// Subscribes to a media query and re-renders when it flips. Private: callers pick one of the
// named tiers below rather than passing a string, so the breakpoints stay in one place.
function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);

    mediaQuery.addEventListener('change', handleChange);
    setMatches(mediaQuery.matches);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

// At or below 480px — a phone held upright. Where the action buttons stack.
// Must stay in step with the media query in cookie-preference-modal.scss.
export function useLargeMobileView() {
  return useMediaQuery(`(max-width: ${LARGE_MOBILE_BREAKPOINT}px)`);
}

// At or below 768px — a phone on its side, or a small tablet. Where the SDK forces the banner
// to full width and bottom, and where the compact banner variant is switched off.
export function useLandscapeMobileView() {
  return useMediaQuery(`(max-width: ${LANDSCAPE_MOBILE_BREAKPOINT}px)`);
}
